export default __webpack_public_path__ + "static/WhyteMedium-83b2e899f71b3fa9a009bf96bd302721.woff";